import type { LogLevel } from '@brickup/shared/dto'
import { oneOf, stringFilter } from '@/components/Internal/DataTable'

const LOG_LEVELS: LogLevel[] = [
  'trace',
  'debug',
  'info',
  'warn',
  'error',
  'fatal',
]

export const logListFilters = {
  level: oneOf<LogLevel | undefined>(LOG_LEVELS, undefined),
  search: stringFilter(),
}
